// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentProcessing_DocumentProcessing__Zgh3P {
  height: 100%;
}
.DocumentProcessing_DocumentProcessing__Zgh3P .DocumentProcessing_Tabs__c\\+k\\+D {
  background: #ffffff;
  margin: -24px -24px 0px;
  height: 77vh;
}
.DocumentProcessing_DocumentProcessing__Zgh3P .DocumentProcessing_Tabs__c\\+k\\+D .DocumentProcessing_ant-tabs-content-holder__H4m7d, .DocumentProcessing_DocumentProcessing__Zgh3P .DocumentProcessing_ant-tabs-content-holder__H4m7d .DocumentProcessing_ant-tabs-content__reuBM {
  height: 100% !important;
}
.DocumentProcessing_DocumentProcessing__Zgh3P .DocumentProcessing_footer__gjM\\+r > div {
  z-index: 99 !important;
  height: 7vh;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/tables/components/DocumentProcessing/DocumentProcessing.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ;AAEE;EACE,uBAAA;AAAJ;AAGE;EACE,sBAAA;EACA,WAAA;AADJ","sourcesContent":[".DocumentProcessing {\n  height: 100%;\n\n  .Tabs {\n    background: #ffffff;\n    margin: -24px -24px 0px;\n    height: 77vh;\n  }\n\n  .Tabs .ant-tabs-content-holder, .ant-tabs-content-holder .ant-tabs-content {\n    height: 100% !important;\n  }\n\n  .footer > div {\n    z-index: 99!important;\n    height: 7vh;\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DocumentProcessing": `DocumentProcessing_DocumentProcessing__Zgh3P`,
	"Tabs": `DocumentProcessing_Tabs__c+k+D`,
	"ant-tabs-content-holder": `DocumentProcessing_ant-tabs-content-holder__H4m7d`,
	"ant-tabs-content": `DocumentProcessing_ant-tabs-content__reuBM`,
	"footer": `DocumentProcessing_footer__gjM+r`
};
export default ___CSS_LOADER_EXPORT___;
